const VALID_CARE_TYPES = new Set(['babysitter', 'nanny', 'pet_care', 'housekeeping', 'companion_care']);

const normalizeCareType = (value?: string | null): string | null => {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  const snakeCase = trimmed
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/-/g, '_')
    .toLowerCase();

  if (VALID_CARE_TYPES.has(snakeCase)) {
    return snakeCase;
  }

  return null;
};

const appendReturnPath = (baseUrl: string, returnPath?: string | null): string => {
  if (!returnPath) return baseUrl;

  const url = new URL(baseUrl, 'http://localhost');
  url.searchParams.set('return_path', returnPath);
  return url.pathname + url.search;
};

export type ProviderProfilePreservedQuery = {
  return_path?: string;
  preview_mode?: string;
};

export const getProviderProfilePreservedQuery = (
  route: { query?: Record<string, unknown> } | undefined
): ProviderProfilePreservedQuery => {
  const query: ProviderProfilePreservedQuery = {};
  if (!route?.query) return query;

  const returnPath = route.query.return_path ?? route.query.returnPath;
  if (typeof returnPath === 'string' && returnPath.length > 0) {
    query.return_path = returnPath;
  }
  if (route.query.preview_mode === 'true') {
    query.preview_mode = 'true';
  }

  return query;
};

const getProviderProfileUrl = (
  sitterId?: string | null,
  careType?: string | null,
  providerType?: string | null,
  returnPath?: string | null
): string | null => {
  if (!sitterId) return null;

  const normalizedCareType = normalizeCareType(careType) || normalizeCareType(providerType);
  if (!normalizedCareType) return null;

  const baseUrl = `/provider/profile/${normalizedCareType}/${sitterId}`;
  return appendReturnPath(baseUrl, returnPath);
};

export default getProviderProfileUrl;
